import * as actions from './lookups-action-creator';
import * as api from './lookups-api';
import * as MsgBarActions from '../system-shared/message-bar-action-creator';

export const loadRelationships = () => (dispatch) =>
  api.getRelationshipsLookup()
    .then(
      (response) => dispatch(actions.loadRelationshipsSuccess(response.data)),
      (axiosResponse) => {
        const error = axiosResponse.response;
        dispatch(MsgBarActions.showErrorMessage(error.message));
      }
    );

export const loadCountries = () => (dispatch) =>
  api.getCountriesLookup()
    .then(
      (response) => dispatch(actions.loadCountriesSuccess(response.data)),
      (axiosResponse) => {
        const error = axiosResponse.response;
        dispatch(MsgBarActions.showErrorMessage(error.message));
      }
    );

export const loadPreferredCommunications = () => (dispatch) =>
  api.getPreferredCommunicationsLookup()
    .then(
      (response) => dispatch(actions.loadPreferredCommunicationsSuccess(response.data)),
      (axiosResponse) => {
        const error = axiosResponse.response;
        dispatch(MsgBarActions.showErrorMessage(error.message));
      }
    );

export const loadStates = () => (dispatch) =>
  api.getStatesLookup()
    .then(
      (response) => dispatch(actions.loadStateSuccess(response.data)),
      (axiosResponse) => {
        const error = axiosResponse.response;
        dispatch(MsgBarActions.showErrorMessage(error.message));
      }
    );

